<template>
    <v-form v-model="valid" ref="form" v-on:submit.prevent="noop" @keyup.native.enter="submit">
        <v-text-field label="##&en Name ##&hu Név ##" v-model="name" :rules="nameRules" required autofocus></v-text-field>
        <v-btn :disabled="!valid" v-show="btn_title" @click="submit">{{ btn_title }}</v-btn>
    </v-form>
</template>

<script>
export default {
    name: "form-for-name",
    props: ["btn_title"],
    data() {
        var default_name = "";
        //if (ß.DEBUG) if (ß.MODE === "development") default_name = ß.HOSTNAME.split('.')[0] + " Admin";

        return {
            valid: false,
            name: default_name,
            nameRules: [
                // fires all the time
                //  message-transition-enter-active message-transition-enter-to
                v => !!v || '##&en Name is required ##&hu A név megadása követelmény ##',
                v => (v && v.length > 4) || '##&en Name is too short ##&hu Túl rövid ##',
            ]
        };
    },
    methods: {
        submit() {
            //this.$refs.form.validate();
            this.$emit("return", this.name);
        },
        noop() {}
    }
};
</script>